// Source file for secure wallet bundle with WalletConnect v2
import EthereumProvider from '@walletconnect/ethereum-provider';

console.log('Secure wallet bundle loaded');

// Detect mobile device
function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

// Global WalletConnect provider
let wcProvider: any = null;

// Toggle wallet options dropdown
function toggleWalletOptions() {
  const dropdown = document.getElementById('walletDropdown');
  dropdown?.classList.toggle('hidden');
}

// Close dropdown when clicking outside
document.addEventListener('click', function(e) {
  const container = document.querySelector('.wallet-container');
  const dropdown = document.getElementById('walletDropdown');
  if (container && e.target instanceof Node && !container.contains(e.target)) {
    dropdown?.classList.add('hidden');
  }
});

async function connectWallet(walletType: string) {
  console.log('Connecting to:', walletType, '| Mobile:', isMobile());
  const dropdown = document.getElementById('walletDropdown');
  dropdown?.classList.add('hidden');
  
  const mobile = isMobile();
  
  try {
    if (walletType === 'metamask') {
      await connectMetaMask(mobile);
    } else if (walletType === 'coinbase') {
      await connectCoinbase(mobile);
    } else if (walletType === 'walletconnect') {
      await connectWalletConnect(mobile);
    }
  } catch (error: any) {
    console.error('Connection error:', error);
    alert('Connection failed: ' + error.message);
  }
}

async function connectMetaMask(mobile: boolean) {
  console.log('MetaMask connection attempt - Mobile:', mobile);
  
  let metamaskProvider: any = null;
  
  if ((window as any).ethereum) {
    if ((window as any).ethereum.isMetaMask) {
      metamaskProvider = (window as any).ethereum;
    } else if ((window as any).ethereum.providers) {
      metamaskProvider = (window as any).ethereum.providers.find((p: any) => p.isMetaMask);
    }
  }
  
  if (!metamaskProvider) {
    if (mobile) {
      const currentHost = window.location.host;
      const deepLink = `metamask://dapp/${currentHost}${window.location.pathname}`;
      const universalLink = `https://metamask.app.link/dapp/${currentHost}${window.location.pathname}`;
      
      localStorage.setItem('walletConnectionAttempt', 'true');
      localStorage.setItem('returnToShopping', 'true');
      
      window.location.href = deepLink;
      setTimeout(() => window.open(universalLink, '_blank'), 1000);
    } else {
      alert('Please install MetaMask browser extension');
    }
    return;
  }
  
  await connectWithProvider(metamaskProvider, 'MetaMask');
}

async function connectCoinbase(mobile: boolean) {
  const ethereum = (window as any).ethereum;
  const coinbaseProvider = ethereum?.providers?.find((p: any) => p.isCoinbaseWallet) || 
                          (ethereum?.isCoinbaseWallet ? ethereum : null);
  
  if (!coinbaseProvider) {
    if (mobile) {
      const currentUrl = encodeURIComponent(window.location.href);
      const deepLink = `https://go.cb-w.com/dapp?cb_url=${currentUrl}`;
      
      localStorage.setItem('walletConnectionAttempt', 'true');
      localStorage.setItem('returnToShopping', 'true');
      
      window.location.href = deepLink;
    } else {
      alert('Please install Coinbase Wallet extension or mobile app');
    }
    return;
  }
  
  await connectWithProvider(coinbaseProvider, 'Coinbase Wallet');
}

async function connectWalletConnect(mobile: boolean) {
  console.log('WalletConnect v2 connection attempt');
  
  try {
    // Create WalletConnect v2 Provider
    wcProvider = await EthereumProvider.init({
      projectId: "3c4e63c73e2c0e3c073e1af5e62f9e21",
      chains: [8453],
      showQrModal: true,
      qrModalOptions: {
        themeMode: "light",
        themeVariables: {
          "--wcm-z-index": "9999"
        }
      },
      rpcMap: {
        8453: "https://mainnet.base.org",
      },
      metadata: {
        name: "Shopcoin",
        description: "Earn $SHOP on everyday shopping.",
        url: window.location.origin,
        icons: [window.location.origin + "/brand/app-icon-512.png"]
      }
    });

    await wcProvider.enable();
    await connectWithProvider(wcProvider, 'WalletConnect');
  } catch (error: any) {
    console.error('WalletConnect connection error:', error);
    if (wcProvider) {
      try {
        await wcProvider.disconnect();
      } catch (e) {
        console.error('Error disconnecting:', e);
      }
      wcProvider = null;
    }
    throw new Error('Failed to connect with WalletConnect. Please try again.');
  }
}

const BASE_CHAIN_ID = '0x2105';

async function ensureBaseChain(provider: any) {
  let currentChainId: string | null = null;
  try {
    currentChainId = await provider.request({ method: 'eth_chainId' });
  } catch (e) {
    console.warn('Could not read current chainId:', e);
  }

  if (currentChainId === BASE_CHAIN_ID) {
    return;
  }

  try {
    await provider.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: BASE_CHAIN_ID }]
    });
  } catch (switchError: any) {
    if (switchError && (switchError.code === 4902 || switchError.code === -32603)) {
      await provider.request({
        method: 'wallet_addEthereumChain',
        params: [{
          chainId: BASE_CHAIN_ID,
          chainName: 'Base',
          nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
          rpcUrls: ['https://mainnet.base.org'],
          blockExplorerUrls: ['https://basescan.org']
        }]
      });
    } else {
      throw new Error('Please switch your wallet to the Base network to continue.');
    }
  }

  let finalChainId: string | null = null;
  try {
    finalChainId = await provider.request({ method: 'eth_chainId' });
  } catch (e) {
    console.warn('Could not confirm chainId after switch:', e);
  }
  if (finalChainId && finalChainId !== BASE_CHAIN_ID) {
    throw new Error('Please switch your wallet to the Base network to continue.');
  }
}

async function connectWithProvider(provider: any, walletName: string) {
  console.log(`Connecting to ${walletName}...`);
  
  try {
    const accounts = await provider.request({
      method: 'eth_requestAccounts'
    });
    
    if (accounts && accounts[0]) {
      const address = accounts[0];

      await ensureBaseChain(provider);

      const shortAddress = address.slice(0, 6) + '...' + address.slice(-4);
      
      const btn = document.getElementById('connectWalletBtn');
      if (btn) {
        btn.textContent = shortAddress;
        (btn as any).style.backgroundColor = '#1B7A6E';
        (btn as any).style.color = 'white';
        (btn as any).style.borderColor = '#1B7A6E';
      }
      
      console.log(`Connected to ${walletName}:`, address);
      
      localStorage.setItem('walletConnected', 'true');
      localStorage.setItem('walletAddress', address);
      localStorage.setItem('walletName', walletName);
      
      showConnectionSuccess(shortAddress, walletName);
    } else {
      throw new Error('No accounts found in wallet');
    }
  } catch (error: any) {
    console.error(`${walletName} connection error:`, error);
    throw error;
  }
}

function showConnectionSuccess(shortAddress: string, walletName: string) {
  const modal = document.createElement('div');
  modal.id = 'successModal';
  
  const overlay = document.createElement('div');
  overlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
  `;
  
  const content = document.createElement('div');
  content.style.cssText = `
    background: white;
    padding: 24px;
    border-radius: 12px;
    max-width: 400px;
    margin: 20px;
    text-align: center;
    box-shadow: 0 10px 25px rgba(0,0,0,0.2);
  `;
  
  const checkmark = document.createElement('div');
  checkmark.style.cssText = 'color: #1B7A6E; font-size: 48px; margin-bottom: 16px;';
  checkmark.textContent = '✓';
  
  const heading = document.createElement('h3');
  heading.style.cssText = 'margin: 0 0 8px; color: #333;';
  heading.textContent = 'Wallet Connected!';
  
  const walletInfo = document.createElement('p');
  walletInfo.style.cssText = 'color: #666; margin: 0 0 16px;';
  walletInfo.textContent = `${walletName}: ${shortAddress}`;
  
  const message = document.createElement('p');
  message.style.cssText = 'color: #333; margin: 0 0 20px; font-weight: 600;';
  message.textContent = 'Ready to shop with crypto rewards!';
  
  const buttonContainer = document.createElement('div');
  buttonContainer.style.cssText = 'display: flex; gap: 12px; justify-content: center;';
  
  const shopButton = document.createElement('button');
  shopButton.style.cssText = `
    background: #1B7A6E;
    color: white;
    border: none;
    padding: 12px 20px;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
  `;
  shopButton.textContent = 'Start Shopping';
  shopButton.onclick = () => (window as any).startShopping();
  
  const closeButton = document.createElement('button');
  closeButton.style.cssText = `
    background: #f5f5f5;
    color: #333;
    border: 1px solid #ddd;
    padding: 12px 20px;
    border-radius: 8px;
    cursor: pointer;
  `;
  closeButton.textContent = 'Close';
  closeButton.onclick = () => (window as any).closeSuccessModal();
  
  buttonContainer.appendChild(shopButton);
  buttonContainer.appendChild(closeButton);
  
  content.appendChild(checkmark);
  content.appendChild(heading);
  content.appendChild(walletInfo);
  content.appendChild(message);
  content.appendChild(buttonContainer);
  
  overlay.appendChild(content);
  modal.appendChild(overlay);
  document.body.appendChild(modal);
}

function startShopping() {
  closeSuccessModal();
  const featuredSection = document.querySelector('.section');
  if (featuredSection) {
    featuredSection.scrollIntoView({ behavior: 'smooth' });
  }
}

function closeSuccessModal() {
  const modal = document.getElementById('successModal');
  if (modal) {
    modal.remove();
  }
}

// Expose functions globally for onclick handlers
(window as any).toggleWalletOptions = toggleWalletOptions;
(window as any).connectWallet = connectWallet;
(window as any).startShopping = startShopping;
(window as any).closeSuccessModal = closeSuccessModal;
